import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/Clipboard_Check.svg'
import _imports_1 from '@/assets/close-icon-2.svg'
import _imports_2 from '@/assets/star-icon.svg'


const _hoisted_1 = { class: "w-full h-screen fixed top-0 left-0 bg-black/75 z-[1000]" }
const _hoisted_2 = { class: "w-full max-w-[854px] min-h-[316px] px-[20px] fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-[7px] bg-white z-[1000]" }
const _hoisted_3 = { class: "flex items-center justify-between py-[16px] mb-[16px] border-b border-[#E3E1EA]" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "ml-[8px] text-[20px] font-semibold text-[#393840]" }
const _hoisted_6 = { class: "max-h-[400px] py-[40px] flex flex-col items-center border-b border-[#E3E1EA] rounded-tl-[7px]" }
const _hoisted_7 = { class: "min-w-[272px] text-center text-[24px] font-bold text-[#393840] leading-[26px]" }
const _hoisted_8 = { class: "py-[12px] flex items-center justify-end" }
const _hoisted_9 = { class: "text-[#393840]" }


import { useTranslate } from "@/composables/useTranslate";

type Props = {
  isReportDialogOpen: boolean;
  bonusReportDate: string;
};

type Emits = {
  (event: "onClose"): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'BonusReportSuccess',
  props: {
    isReportDialogOpen: { type: Boolean },
    bonusReportDate: {}
  },
  emits: ["onClose"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;
const { t } = useTranslate();

const handleClose = () => {
  emits("onClose");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "nested" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[2] || (_cache[2] = _createElementVNode("img", {
                class: "w-[24px] h-[24px]",
                src: _imports_0,
                alt: ""
              }, null, -1)),
              _createElementVNode("p", _hoisted_5, _toDisplayString(__props.bonusReportDate), 1)
            ]),
            _createElementVNode("img", {
              class: "h-[12px] w-[12px] cursor-pointer",
              src: _imports_1,
              alt: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClose()))
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[3] || (_cache[3] = _createElementVNode("img", {
              class: "h-[60px] w-[60px] mb-[20px]",
              src: _imports_2,
              alt: ""
            }, null, -1)),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)("installers.report_upload_success")), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (handleClose())),
              class: "w-[150px] flex items-center justify-center p-[12px] gap-[8px] text-[16px] text-white font-semibold border-2 border-[#393840] rounded-[7px]"
            }, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)("global.close")), 1)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})